module.exports = __webpack_public_path__ + "img/pencil.0329a9e3.svg";